export const environment = {
  production: false,
  server: "aws", // This will be overwritten by the script during build time
  eth: {
    chainId: '0xaa36a7', //hexadecimal for metamask
    chainIdInt: 11155111,
    chainName: 'Ethereum Mainnet',
    gasFees: 0,
    purchaseToken: 'ETH',
    hasStaking: true,
    nativeFunction: 'buyWithEth',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    presaleAddress: '0x9C1Acda2f361e800Cd06da12AD86C34fd84aC91c',
    usdTAddress: '0x9fa2AE3c0a571BbBFd17E74d7470b6c444A87aF2',
    usdcAddress: '0x232331e4e45582742A2D717562Cd682fA132b799',
    rpcURL: 'https://cosmopolitan-dimensional-violet.quiknode.pro/4b366ec5068bc90574dd6d2c1416f127dc4111cd',
    backupRPC: 'https://cosmopolitan-dimensional-violet.quiknode.pro/4b366ec5068bc90574dd6d2c1416f127dc4111cd',
    blockExplorerURL: 'https://etherscan.io/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0xaa36a7',
          chainName: 'Ethereum Mainnet',
          nativeCurrency: {
            name: 'ETH',
            symbol: 'ETH',
            decimals: 18,
          },
          rpcUrls: ['https://rpc.ankr.com/eth'],
          blockExplorerUrls: ['https://etherscan.io/'],
        },
      ],
    },
  },

  bsc: {
    chainId: '0x61', //hexadecimal for metamask
    chainIdInt: 97,
    chainName: 'BSC Mainnet',
    gasFees: 0,
    purchaseToken: 'BNB',
    hasStaking: false,
    nativeFunction: 'buyWithBNB',
    presaleAddress: '0xb1955914D6268D6039dA783769a0Ccb02b31A1Dd',
    multicall: '0xca11bde05977b3631167028862be2a173976ca11',
    usdTAddress: '0xADFc9B54FB7a1677176A7529F03b91081C91355c',
    usdcAddress: '0xF4053F70d6cC72C0473F2a9E42176DB818D24454',
    rpcURL: 'https://cosmopolitan-dimensional-violet.bsc.quiknode.pro/4b366ec5068bc90574dd6d2c1416f127dc4111cd',
    backupRPC: 'https://cosmopolitan-dimensional-violet.bsc.quiknode.pro/4b366ec5068bc90574dd6d2c1416f127dc4111cd',
    blockExplorerURL: 'https://bscscan.com/tx/',
    chainInfo: {
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainId: '0x61',
          chainName: 'BSC Mainnet',
          nativeCurrency: {
            name: 'BNB',
            symbol: 'BNB',
            decimals: 18,
          },
          rpcUrls: ['https://bsc-dataseed.binance.org'],
          blockExplorerUrls: ['https://bscscan.com/'],
        },
      ],
    },
  },

  minToken: 0,
  stakingAddress: '0xfC8aFBD55a9b9994f09ef79fa3D6Bee1357d8B43',
  apyCalcConst: '7887003803',
  stakeUnlockTime: 1912943476000,
  tokenName: '$PEPENODE',
  walletConnectId: 'ab1e047576b21ceac0133e45b0d920b6',
  iidDashFx: 2363,
  urlDashFx_aws: '',
  urlDashFx_firebase: '',
  urlDashFx_cloudfront: '',
  wertOrigin: 'https://sandbox.wert.io', // testnet
  partnerId: '01K1AR1D7R4TZEVAFCSQPJNJFJ', // testnet
  wertUrl: 'https://ijs2jkwmnzohnnjppqkypl2avq0hhlcm.lambda-url.eu-west-2.on.aws/', // testnet
  referUrl: 'https://fztdp5he4ueq4nytzyj2ycx7vm0wwqth.lambda-url.eu-west-2.on.aws/',
  bwUniversalLink: 'https://best-wallet-dev.web.app',
  bwDeepLink: 'bw-dev://app/connect?',
  bwApiUrl: 'https://d19yvvzbif6vnj.cloudfront.net/webhook-service-api/presale',
  showBestWallet: false,
  domain: 'https://www.pepenode.io', // replace with live site URL
  sseUrl: '',
  notificationTimeout: 7000,
  presaleName: 'Pepenode',
  presale_singular_link: 'https://best.sng.link/Dnio2/0v8lo?_smtype=3',
  post_presale_singular_link: 'https://best.sng.link/Dnio2/tmln?_smtype=3',
  wertOnRampUrl: 'https://bxznhachfmvnm2owk6c7s2rq2a0xfhbg.lambda-url.eu-west-2.on.aws/', //will change according to the presales.,
  transactionUrl:"https://dtxw9xix4exl0.cloudfront.net/presale-analytics-service/v1/api/transactions/$NODE?count=10&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzbHVnIjoiJE5PREUiLCJpYXQiOjE3NTM2ODM2MjJ9.u6MR_HKgg8ehclWvV8AGapCtjpMDwmtVBV8gSsgZQ3I",
  tokenAddress:"0xd29191a6D2Aae7C0E60F4722018832aDdF4b9831"
};
